import { isCustomAuthEnabled } from 'modules/auth/config/authConfig';

/**
 * Intercept Cognito SAML callback when using custom auth provider (e.g. AXA with Myriam).
 * When Cognito redirects back with ?code= in the main URL (before the hash),
 * HashRouter can't see it. Redirect to #/callback so CognitoSamlCallback can process it.
 *
 * Only runs when REACT_APP_AUTH_PROVIDER=custom to avoid breaking Auth0 flows
 * (Auth0 needs code+state in the query string; this redirect would drop state).
 */
export const initSamlCallbackRedirect = () => {
  if (!isCustomAuthEnabled()) return;

  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');

  if (code && !window.location.hash.includes('/callback')) {
    const { origin, pathname } = window.location;
    const encodedCode = encodeURIComponent(code);

    const callbackUrl = `${origin}${pathname}#/callback?code=${encodedCode}`;

    window.location.replace(callbackUrl);
  }
};
